var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VirtualGamesSidebarContainer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
var activeItem = ref.activeItem;
var onItemClick = ref.onItemClick;
return _c('div',{staticClass:"nav-sidebar"},[_c('div',{staticClass:"nav-sidebar__wrapper"},[_c('Tree',{attrs:{"items":items,"activeIds":[activeItem.name],"showItemCount":false,"showToplevelFlag":false},on:{"itemClick":function (ref) {
	var item = ref[0];

	return onItemClick(item);
}}})],1)])}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98e07b40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/games/virtuals/components/Sidebar.vue
// module id = 2196
// module chunks = 0